import { defineComponent as _defineComponent } from 'vue'
import { LocaleMessages } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'TG4Button',
  props: {
    title: null,
    id: null,
    primary: { type: Boolean, default: true },
    large: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { title: string | LocaleMessages, id: string, primary: boolean, large: boolean };




return { __sfc: true,props }
}

})